import { render, staticRenderFns } from "./StampableLocatorMenu.vue?vue&type=template&id=6ae659fe&scoped=true&"
import script from "./StampableLocatorMenu.vue?vue&type=script&lang=ts&"
export * from "./StampableLocatorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StampableLocatorMenu.vue?vue&type=style&index=0&id=6ae659fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae659fe",
  null
  
)

export default component.exports